import { render, staticRenderFns } from "./PowerLimitBreachesTable.vue?vue&type=template&id=f00f6822&scoped=true&"
import script from "./PowerLimitBreachesTable.vue?vue&type=script&lang=ts&"
export * from "./PowerLimitBreachesTable.vue?vue&type=script&lang=ts&"
import style0 from "./PowerLimitBreachesTable.vue?vue&type=style&index=0&id=f00f6822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00f6822",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
